// Admin "What's new" feed — newest first. Add an entry whenever a new
// admin-facing tool ships so it announces itself on /admin.
export const ADMIN_WHATS_NEW = [
  {
    date: "2026-09-11",
    title: "Monthly plans now auto-renew",
    blurb: "New plan purchases renew via Stripe until canceled — no more silent 30-day lapses.",
    link: "/admin/payments",
  },
  {
    date: "2026-09-11",
    title: "Renewal + win-back emails",
    blurb: "Members get 'expires in 3 days' and 'your plan lapsed' emails automatically, daily.",
    link: "/admin/users-ops",
  },
  {
    date: "2026-09-11",
    title: "Lapsed plans card",
    blurb: "Users hub now shows who had a plan end in the last 60 days with nothing active.",
    link: "/admin/users?filter=lapsed",
  },
  {
    date: "2026-09-10",
    title: "Share & Invite scripts",
    blurb: "Ready-to-send recruitment emails + texts for every persona, your referral link baked in.",
    link: "/admin/share-invite",
  },
  {
    date: "2026-09-10",
    title: "Referral leaderboard",
    blurb: "See which members bring in the most signups — bottom of the Users hub.",
    link: "/admin/users-ops",
  },
  {
    date: "2026-09-10",
    title: "Member invite page",
    blurb: "Every member now has their own invite link + scripts under Explore → Invite friends.",
    link: "/invite",
  },
  {
    date: "2026-09-10",
    title: "Deleted accounts card + filter",
    blurb: "Tombstones get their own card and user-list filter; every other count shows actual members only.",
    link: "/admin/users-ops",
  },
  {
    date: "2026-09-10",
    title: "Revenue front & center",
    blurb: "Monthly revenue banner here on Operations, full month-by-month breakdown on Payments & revenue.",
    link: "/admin/payments",
  },
  {
    date: "2026-09-10",
    title: "Self-cleaning payments page",
    blurb: "Stripe verifies unpaid checkouts nightly and hides abandoned carts automatically — no reconciling.",
    link: "/admin/payments",
  },
  {
    date: "2026-09-09",
    title: "Stripe Tax 3-step setup",
    blurb: "Sellers get an action-first checklist with a live status check instead of a wall of text.",
    link: "/help/stripe-tax-setup",
  },
];
